import rightarrow from "@/assets/images/static/right_arrow.png";
import financing from "@/assets/images/static/financing.webp";
import displayIcon from "@/assets/images/static/displayIcon.webp";
import DeliveryIcon from "@/assets/images/static/delivery_Icon.png";

import JennAirBanner from "@/assets/images/static/brands/Jennair/JennAirBanner.png";
import JennAirBannerMobile from "@/assets/images/static/brands/Jennair/JennAirBannerMobile.png";

import { allBrandList } from "@/components/BrandDetail/arraybrandlist";
import Link from "next/link";
import Image from "next/image";

const VideoSection = ({ brandName }) => {
  const DataResponse = allBrandList.find((item) => item[brandName])?.[
    brandName
  ];
  const videoLinkUrl = DataResponse?.videoLink ? DataResponse.videoLink : [];
  // Function to extract video ID
  function getYouTubeVideoId(url) {
    if (!url || typeof url !== "string") {
      return null; // Return null if the URL is invalid
    }

    try {
      const urlObj = new URL(url);
      const urlParams = new URLSearchParams(urlObj.search);
      return urlParams.get("v"); // Return the video ID if found
    } catch (error) {
      return null; // Return null if URL parsing fails
    }
  }

  const videoId = getYouTubeVideoId(videoLinkUrl);
  const videoUrl = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&origin=https%3A%2F%2Fwww.airportappliance.com`;
  
  const brandNameMapping = new Map([
    ["U_Line", "U-Line"],
    ["Lg", "LG"],
    ["Lg_Studio", "LG Studio"],
    ["Kitchenaid", "KitchenAid"],
    ["Ge_Profile", "GE Profile"],
    ["Ge_Appliances", "GE"],
  ]);
  
  const formattedBrandName = brandNameMapping.get(brandName) 
    || brandName.replace(/Appliances/g, "").replace(/_/g, " ").trim();
    
  return (
    <div className={`max-w-[1480px] mx-auto my-0 px-5 py-[60px] lg:py-7`}>
      {brandName === 'Jennair' &&<div className=" w-full mb-[48px] lg:mb-[24px] overflow-hidden  ">
        <Link href="/jennair-curate">
          <Image src={JennAirBanner} alt="ad-banner" className=" sm:hidden" />
          <Image src={JennAirBannerMobile} alt="ad-banner" className=" hidden sm:block "/>
        </Link>
      </div>}
      <div className="flex items-center gap-x-[100px] gap-y-4 lg:flex-col">
        <div className=" flex-1 max-w-[630px]">
            <ul className="grid grid-cols-1 gap-[28px] mt-4 mb-4 ">
              <li className="bg-[#ffffff] rounded-[18px] text-base text-[#3C3C43D9] p-[25px] shadow-brandsStaticCard border-[1px] border-[#ececec]">
               <Link href={"/next-day-delivery"} className="gap-5 flex justify-between items-center">
                  <div className="flex gap-4 items-center mob:flex-col mob:items-start">
                  <div className="w-[79px] h-[100%] relative">
                    <Image
                      src={DeliveryIcon}
                      alt="banner"
                      
                      className="object-contain w-full h-full"
                    />
                  </div>
                  <div>
                    <h4 className="text-[16px] text-black font-semibold mb-2">                  
                    Next-Day Delivery
                    </h4>
                    <p className="text-[14px] leading-normal" >
                    Shop in-stock {formattedBrandName} appliances and receive next-day delivery.*
                    </p>
                  </div>
                  </div>
                  <div className="min-w-[40px] min-h-[30px] relative">
                    <Image
                      src={rightarrow}
                      alt="banner"
                      className="object-cotain"
                    />
                  </div>
                </Link>
              </li>
              <li className="bg-[#ffffff] rounded-[18px] text-base text-[#3C3C43D9] p-[25px] shadow-brandsStaticCard border-[1px] border-[#ececec]">
               <Link href={"/financing"} className="gap-5 flex justify-between items-center">
                <div className="flex gap-4 items-center mob:flex-col mob:items-start">
                <div className="w-[79px] h-[100%] relative">
                  <Image
                    src={financing}
                    alt="banner"
                    
                    className="object-contain w-full h-full"
                  />
                </div>
                <div>
                  <h4 className="text-[16px] text-black font-semibold mb-2">
                    Special Financing Offers
                  </h4>
                  <p className="text-[14px] leading-normal" >
                   Buy now and pay over time with our special financing options.{" "}
                  </p>
                </div>
                </div>
                <div className="min-w-[40px] min-h-[30px]  relative">
                  <Image
                    src={rightarrow}
                    alt="banner"
                    className="object-cotain"
                  />
                </div>
                </Link>
              </li>
              <li className="bg-[#ffffff]  rounded-[18px] text-base text-[#3C3C43D9] p-[25px] shadow-brandsStaticCard border-[1px] border-[#ececec]">
               <Link href={"/stores"} className="gap-5 flex justify-between items-center">
                <div className="flex gap-4 items-center mob:flex-col mob:items-start">
                  <div className="w-[79px] h-[100%] relative">
                    <Image
                      src={displayIcon}
                      alt="banner"
                      
                      className="object-contain w-full h-full"
                    />
                  </div>
                  <div>
                    <h4 className="text-[16px] text-black font-semibold mb-2">
                     Visit a Showroom
                    </h4>
                    <p className="text-[14px] leading-normal" >
                     Experience {formattedBrandName} for yourself at one of our 8 Northern California showrooms.
                    </p>
                  </div>
                  </div>
                  <div className="min-w-[40px] min-h-[30px]  relative">
                    <Image
                      src={rightarrow}
                      alt="banner"
                      className="object-cotain"
                    />
                  </div>
              </Link>
              </li>
            </ul>
        </div>
        <div className=" flex-1 lg:w-full lg:max-w-[630px] ">
          <div className="relative pb-[60%] w-full">
          <iframe
            width="100%"
            src={videoUrl}
            title="Launch video new Freestanding Appliances | Liebherr"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="Ifram  md:p-0 rounded-[15px] overflow-hidden w-full h-full absolute"
            id="53227150"
          ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoSection;